<template>
  <section class="rythm-v section--score">
    <hgroup>
      <h4>Index de BASFI</h4>
      <p class="small">Bath Ankylosing Spondylitis Functional Index</p>
    </hgroup>

    <div>
      <radio-toggle class="radio-group--inline" id="score_basfi_done" name="score_basfi_done" label="Score réalisé ?" v-model="localValues.scoreDone" @input="resetScore"></radio-toggle>
    </div>

    <div v-if="hasScore">
      <p><strong>Saisissez votre réponse en vous référant aux dernières 48 heures :</strong></p>

      <ol class="rythm-v-large">
        <li>
          <RangeInput
            id="basfi_q1"
            class="stripes-10"
            label="Pouvez-vous mettre vos chaussettes ou collants sans l’aide de quelqu’un ou de tout autre moyen extérieur ?<br><em>(ex. : petit appareil vous aidant à mettre les chaussettes)</em>"
            hint=""
            before="Sans aucune difficulté"
            after="Impossible"
            min="0"
            max="10"
            data-display-range="true"
            required
            v-bind="$attrs"
            v-model="localValues.basfi_q1"
            @input="emitScore"
          />
        </li>
        <li>
          <RangeInput
            id="basfi_q2"
            class="stripes-10"
            label="Pouvez-vous vous pencher en avant pour ramasser un stylo posé sur le sol sans l’aide d’un moyen extérieur ?"
            hint=""
            before="Sans aucune difficulté"
            after="Impossible"
            min="0"
            max="10"
            data-display-range="true"
            required
            v-bind="$attrs"
            v-model="localValues.basfi_q2"
            @input="emitScore"
          />
        </li>
        <li>
          <RangeInput
            id="basfi_q3"
            class="stripes-10"
            label="Pouvez-vous atteindre une étagère élevée sans l’aide de quelqu’un ou d’un moyen extérieur ?"
            hint=""
            before="Sans aucune difficulté"
            after="Impossible"
            min="0"
            max="10"
            data-display-range="true"
            required
            v-bind="$attrs"
            v-model="localValues.basfi_q3"
            @input="emitScore"
          />
        </li>
        <li>
          <RangeInput
            id="basfi_q4"
            class="stripes-10"
            label="Pouvez-vous vous lever d’une chaise sans accoudoir sans utiliser vos mains ou tout autre aide ?"
            hint=""
            before="Sans aucune difficulté"
            after="Impossible"
            min="0"
            max="10"
            data-display-range="true"
            required
            v-bind="$attrs"
            v-model="localValues.basfi_q4"
            @input="emitScore"
          />
        </li>
        <li>
          <RangeInput
            id="basfi_q5"
            class="stripes-10"
            label="Pouvez-vous vous relever de la position « couché sur le dos », sans aide ?"
            hint=""
            before="Sans aucune difficulté"
            after="Impossible"
            min="0"
            max="10"
            data-display-range="true"
            required
            v-bind="$attrs"
            v-model="localValues.basfi_q5"
            @input="emitScore"
          />
        </li>
        <li>
          <RangeInput
            id="basfi_q6"
            class="stripes-10"
            label="Pouvez-vous rester debout sans soutien pendant 10 minutes sans ressentir de gêne ?"
            hint=""
            before="Sans aucune difficulté"
            after="Impossible"
            min="0"
            max="10"
            data-display-range="true"
            required
            v-bind="$attrs"
            v-model="localValues.basfi_q6"
            @input="emitScore"
          />
        </li>
        <li>
          <RangeInput
            id="basfi_q7"
            class="stripes-10"
            label="Pouvez-vous monter 12 à 15 marches, en ne posant qu’un pied sur chaque marche, sans vous tenir à la rampe ou utiliser tout autre soutien ?"
            hint=""
            before="Sans aucune difficulté"
            after="Impossible"
            min="0"
            max="10"
            data-display-range="true"
            required
            v-bind="$attrs"
            v-model="localValues.basfi_q7"
            @input="emitScore"
          />
        </li>
        <li>
          <RangeInput
            id="basfi_q8"
            class="stripes-10"
            label="Pouvez-vous regarder par-dessus votre épaule sans vous retourner ?"
            hint=""
            before="Sans aucune difficulté"
            after="Impossible"
            min="0"
            max="10"
            data-display-range="true"
            required
            v-bind="$attrs"
            v-model="localValues.basfi_q8"
            @input="emitScore"
          />
        </li>
        <li>
          <RangeInput
            id="basfi_q9"
            class="stripes-10"
            label="Pouvez-vous effectuer des activités nécessitant un effort physique ? <br><em>(ex : mouvements de kinésithérapie, jardinage ou sports)</em>"
            hint=""
            before="Sans aucune difficulté"
            after="Impossible"
            min="0"
            max="10"
            data-display-range="true"
            required
            v-bind="$attrs"
            v-model="localValues.basfi_q9"
            @input="emitScore"
          />
        </li>
        <li>
          <RangeInput
            id="basfi_q10"
            class="stripes-10"
            label="Pouvez-vous avoir des activités toute la journée, que ce soit au domicile ou au travail ?"
            hint=""
            before="Sans aucune difficulté"
            after="Impossible"
            min="0"
            max="10"
            data-display-range="true"
            required
            v-bind="$attrs"
            v-model="localValues.basfi_q10"
            @input="emitScore"
          />
        </li>
      </ol>

      <div class="alert-success w-100">
        <ul>
          <li>
            <span class="label">Index de BASFI :</span> <strong>{{ score }}</strong>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import RangeInput from "@/components/RangeInput.vue";
import radioToggle from "@/components/radioToggle.vue";

export default {
  name: "ScoreBasfi",
  inheritAttrs: false,
  props: ["value"],

  components: {
    RangeInput,
    radioToggle,
  },

  data() {
    return {
      localValues: {
        scoreDone: "0",
        basfi_q1: 0,
        basfi_q2: 0,
        basfi_q3: 0,
        basfi_q4: 0,
        basfi_q5: 0,
        basfi_q6: 0,
        basfi_q7: 0,
        basfi_q8: 0,
        basfi_q9: 0,
        basfi_q10: 0,
      },
    };
  },

  computed: {
    hasScore() {
      return parseInt(this.localValues.scoreDone);
    },

    scoreValues() {
      return Object.keys(this.localValues).reduce((obj, key) => {
        if (key !== "scoreDone") obj[key] = this.localValues[key];
        return obj;
      }, {});
    },

    score() {
      if (!this.hasScore) return "";
      // average of all localValues values
      const values = Object.values(this.scoreValues).filter((v, k) => k !== "scoreDone");
      return values.reduce((a, b) => this.safeParseInt(a) + this.safeParseInt(b)) / 10;
    },

    results() {
      return {
        score: `${this.score}`, // raw score always as string
        scoreRendered: `Index de BASFI : ${this.score}`, // formatted score, ex. with unit 24%, 12mm, …
        values: { ...this.localValues }, // local values "as is" (do not cast, etc.)
        details: null,
        detailsRendered: "",
      };
    },
  },

  methods: {
    safeParseInt(value) {
      return isNaN(parseInt(value)) ? 0 : parseInt(value);
    },

    emitScore() {
      this.$emit("input", this.results);
    },

    resetScore() {
      if (!this.hasScore) {
        this.localValues = {
          scoreDone: "0",
          basfi_q1: "",
          basfi_q2: "",
          basfi_q3: "",
          basfi_q4: "",
          basfi_q5: "",
          basfi_q6: "",
          basfi_q7: "",
          basfi_q8: "",
          basfi_q9: "",
          basfi_q10: "",
        };
      } else {
        this.localValues = {
          scoreDone: "1",
          basfi_q1: 0,
          basfi_q2: 0,
          basfi_q3: 0,
          basfi_q4: 0,
          basfi_q5: 0,
          basfi_q6: 0,
          basfi_q7: 0,
          basfi_q8: 0,
          basfi_q9: 0,
          basfi_q10: 0,
        };
      }
      this.emitScore();
    },
  },

  watch: {
    // Init local model from `value` prop
    value: {
      immediate: true,
      handler: function(results) {
        if (results?.values && parseInt(results.values.scoreDone)) {
          this.localValues = { ...results.values };
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .input-slider {
    .input-slider-label,
    .range-slider {
      flex-basis: 100% !important;
    }

    .input-slider-label {
      gap: 1rem;
    }

    .label--before,
    .label--after {
      flex-basis: 15%;
    }
  }
}
</style>
